import type { SportUiConfiguration } from "../../types/sportUiConfiguration.ts";
import { defaultsUiConfig } from "./defaultsUi.ts";

export const basketballUiConfig: SportUiConfiguration = {
  ...defaultsUiConfig,
};
